module.exports = __webpack_public_path__ + "assets/img/patientList-picwoman.c85f7984.png";